export default __webpack_public_path__ + "static/media/card-success-dark.78d8d8a2.svg";